import socket from '@/plugins/socket'

export default {
  namespaced: true,
  state: {
    list: [],
    filtered: []
  },
  mutations: {
    init: (state, data) => { state.list = data.sort((a, b) => a.name.localeCompare(b.name)) },
    filtered: (state, data) => { state.filtered = data.map(item => item.id) }
  },
  actions: {
    init (state) { socket.get('SportSportSport', 'Sport/Sport/init') },
    set (state, data) {
      state.state.filtered = []

      const parameters = {}
      if (data.seasonId > 0 || data.competitionsId.length > 0) {
        parameters.joinr = [
          'SportSportDiscipline.sportId',
          'SportSportEvent.disciplineId',
          'SportSportEventunit.eventId',
          'SportSportRound.eventUnitId'
        ]
        parameters.join = ['SportSportRound.competitionSeasonId']

        if (data.seasonId > 0) {
          parameters['SportSportCompetitionseason.seasonId'] = data.seasonId
        }

        if (data.competitionsId.length === 1) {
          parameters['SportSportCompetitionseason.competitionId'] = data.competitionsId[0]
        } else if (data.competitionsId.length > 1) {
          parameters['SportSportCompetitionseason.competitionId'] = {
            column: 'SportSportCompetitionseason.competitionId',
            operator: 'in',
            value: data.competitionsId
          }
        }
      }

      socket.get('SportSportSport', 'Sport/Sport/filtered', parameters)
    }
  },
  getters: {
    list: (state) => state.list,
    filtered: (state) => state.filtered,
    get: (state) => (id) => state.list.find(item => item.id === id)
  }
}
